import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { saveLocalStorage } from "components/Helper/Helper";
import { isAuthenticated } from 'utils/authHelper';

// ChatBot module ID from getUserMappingModules API
const CHATBOT_MODULE_ID = 19;

const FloatingButton = styled.button`
  position: fixed;
  bottom: 40px;
  right: 25px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #4f2d7f;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.1);
    background: #4f2d7f;
    box-shadow: 0 6px 16px rgba(0, 123, 255, 0.4);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  svg {
    width: 28px;
    height: 28px;
    fill: white;
  }
`;

// SmartToy icon SVG
const SmartToyIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zM7.5 11.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S9.83 13 9 13s-1.5-.67-1.5-1.5zM16 17H8v-2h8v2zm-1-4c-.83 0-1.5-.67-1.5-1.5S14.17 10 15 10s1.5.67 1.5 1.5S15.83 13 15 13z"/>
  </svg>
);

const FloatingChatButton = () => {
  const history = useHistory();
  const location = useLocation();
  
  // Get modules from Redux state to check ChatBot access
  const modules = useSelector((state) => state.landingReducer?.modules || []);

  // Hide floating button for non-logged-in users (public)
  if (!isAuthenticated()) {
    return null;
  }

  // Hide floating button when on chatbot page
  const isChatBotPage = location.pathname.startsWith('/chat_bot');
  if (isChatBotPage) {
    return null;
  }

  // Hide floating button for logged-in users who don't have ChatBot module (moduleId 19)
  const hasChatBotModule = modules.some(
    (module) => module.moduleId === CHATBOT_MODULE_ID
  );
  if (!hasChatBotModule) {
    return null;
  }

  const handleButtonClick = () => {
    // Redirect to full chat bot page (user is authenticated and has access)
    history.push('/chat_bot');
  };

  return (
    <FloatingButton onClick={handleButtonClick}>
      <SmartToyIcon />
    </FloatingButton>
  );
};

export default FloatingChatButton;